export const SEARCH_ID_DIMENSION = '38';
export const PRODUCT_DIMENSION = '35';
export const FLIGHT_TYPE_DIMENSION = '42';
export const FLIGHT_DATES_DIMENSION = '44';
export const LOCATION_DIMENSION = '45';
export const CLASS_FLIGHT_DIMENSION = '46';
export const HOTEL_DATES_DIMENSION = '47';
export const FLIGHT_DESTINATION_DIMENSION = '51';
export const FLIGHT_ORIGIN_DIMENSION = '52';
export const FLIGHT_DISTANCE_DIMENSION = '48';
export const RETURNING_USER_DIMENSION = '65';
export const CARBON_FOOTPRINT_DIMENSION = '72';

export const TRIP_TYPES = {
  ONE_WAY: 'ONE_WAY',
  ROUND_TRIP: 'ROUND_TRIP',
  MULTIPLE_DESTINATIONS: 'MULTIPLE_DESTINATIONS',
};

export const CABIN_CLASS_MAP = {
  BUSINESS: 'business',
  FIRST: 'firstclass',
  TOURIST: 'economy',
  PREMIUM_ECONOMY: 'premiumeconomy',
  ECONOMIC_DISCOUNTED: 'economydiscounted',
};
